import { toBase64 } from '../../../../utils/index.js';
import { BaseWasmQuery } from '../../BaseWasmQuery.js';
export class QueryGetCampaigns extends BaseWasmQuery {
    toPayload() {
        const payload = {
            get_campaigns: {
                campaigns: this.params.campaigns,
            },
        };
        return toBase64(payload);
    }
}
